/**
 * Приложение LightChat в магазинах.
 *
 * С 19.09.2026 приложение для Android опубликовано в RuStore. Сайт при этом
 * не закрывается: на iPhone и компьютере LightChat по-прежнему открывается
 * в браузере, а приложению сайт нужен для оплаты, документов и возврата
 * из ЮKassa. Поэтому Android-посетителю первой кнопкой предлагается
 * магазин, но вход через браузер остаётся рядом — у кого-то RuStore
 * не установлен, и ставить ещё один магазин ради пробы он не станет.
 */

export const ANDROID_PACKAGE = 'com.lightchat.app'

/**
 * Ссылка на страницу приложения — ровно по шаблону из правил кнопки RuStore
 * (rustore.ru/help/developers/advertising-and-promotion/button-rustore):
 * utm_source, rsm и mt_link_id там постоянные, в остальные подставляется
 * имя пакета. По ним магазин считает переходы с нашей кнопки.
 */
export const RUSTORE_URL =
  `https://www.rustore.ru/catalog/app/${ANDROID_PACKAGE}` +
  `?utm_source=available_in_rustore&utm_medium=${ANDROID_PACKAGE}` +
  `&rsm=1&mt_link_id=iios36&mt_sub1=${ANDROID_PACKAGE}`

/**
 * Та же ссылка, но с кодом приглашения: магазин хранит его 90 дней и отдаёт
 * приложению после установки (RuStore Install Referrer, docs/PARTNERS.md).
 * Так код партнёра не теряется по дороге через магазин и человеку не нужно
 * вводить его руками.
 */
export function rustoreUrl(referrer?: string | null): string {
  return referrer ? `${RUSTORE_URL}&referrer=${encodeURIComponent(referrer)}` : RUSTORE_URL
}

/** Телефон или планшет на Android — по строке браузера, другого способа у страницы нет. */
export function isAndroidDevice(): boolean {
  if (typeof navigator === 'undefined') return false
  return /android/i.test(navigator.userAgent)
}
